var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4248 4.375L11.9248 1.9L13.1498 0.675C13.3331 0.475 13.5665 0.375 13.8498 0.375C14.1331 0.375 14.3748 0.475 14.5748 0.675L15.6248 1.75C15.8248 1.93333 15.9248 2.16667 15.9248 2.45C15.9248 2.73333 15.8331 2.96667 15.6498 3.15L14.4248 4.375ZM1.1248 16C0.891471 16 0.695471 15.925 0.536805 15.775C0.378805 15.625 0.299805 15.4333 0.299805 15.2V13.825C0.299805 13.725 0.320471 13.6293 0.361804 13.538C0.403804 13.446 0.466471 13.35 0.549805 13.25L11.1998 2.6L13.6998 5.1L3.0498 15.75C2.96647 15.85 2.87914 15.9167 2.7878 15.95C2.6958 15.9833 2.59147 16 2.4748 16H1.1248Z",
    fill: "#006EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.36b01442f6d5cda4adb351a1cf11e978.svg";
export { ForwardRef as ReactComponent };